export default __webpack_public_path__ + "static/media/HOME (dark).13811cd4.png";